import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../styles/pages/CierreAnual.css';
import { API_BASE_URL } from '../config';


const CierreAnual = ({ token, id_company }) => {
  const [estado, setEstado] = useState([]);
  const [procesando, setProcesando] = useState(false);
  const [mensajeProcesando, setMensajeProcesando] = useState('');
  const fetchEstado = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/cierre-anual`, {
        params: { company: id_company },
        headers: { Authorization: `Bearer ${token}` }
      });
      setEstado(res.data);
    } catch (err) {
      console.error('Error al obtener cierre anual:', err);
    }
  };
  useEffect(() => {
    if (id_company && token) fetchEstado();
  }, [id_company, token]);

  const toggleAnio = async (anio, cerrado) => {
    if (procesando) return; // evita doble clic mientras ya hay un proceso en curso
    const nuevoCerrado = !cerrado;
    setMensajeProcesando(
      nuevoCerrado
        ? `Cerrando el año ${anio}... esto puede tardar unos segundos.`
        : `Reabriendo el año ${anio}...`
    );
    setProcesando(true);
    try {
      await axios.post(`${API_BASE_URL}/api/cierre-anual`, {
        company: id_company,
        anio,
        cerrado: nuevoCerrado
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEstado(
        estado.map((e) =>
          e.anio === anio ? { ...e, cerrado: nuevoCerrado } : e
        )
      );
    } catch (err) {
      console.error('Error al actualizar cierre anual:', err);
      const errorMsg =
        err.response?.data?.message || err.response?.data?.error || err.response?.data || 'Error al actualizar cierre anual';
      Swal.fire({
        icon: 'error',
        title: 'No se pudo actualizar el cierre anual',
        text: errorMsg
      });
      // Si falló, el backend no dejó nada a medias: refrescamos el estado real
      // en vez de asumir que quedó cerrado/abierto.
      fetchEstado();
    } finally {
      setProcesando(false);
      setMensajeProcesando('');
    }
  };
  return (
    <div className="cierre-anual">
      <h1>Cierre Anual</h1>
      <table className="cierre-table">
        <thead>
          <tr>
            <th>Año</th>
            <th>Cerrado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {estado.map((row) => (
            <tr key={row.anio}>
              <td>{row.anio}</td>
              <td className={row.cerrado ? 'status-true' : 'status-false'}>
                {row.cerrado ? 'Sí' : 'No'}
              </td>
              <td>
                <button onClick={() => toggleAnio(row.anio, row.cerrado)} disabled={procesando}>
                  {row.cerrado ? 'Abrir año' : 'Cerrar año'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {procesando && (
        <div className="cierre-overlay">
          <div className="cierre-overlay-box">
            <div className="cierre-spinner" />
            <p>{mensajeProcesando || 'Procesando...'}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CierreAnual;
